type ZoneAnchor = {
  zone: string;
};

type DocumentAnchor = {
  document: string;
  revision: number;
  anchor: {
    node: string;
    offset: number;
  };
  focus: {
    node: string;
    offset: number;
  };
};

export type Anchor = ZoneAnchor | DocumentAnchor;

export const isZoneAnchor = (anchor: Anchor): anchor is ZoneAnchor =>
  !!(anchor as ZoneAnchor).zone;

export const isDocumentAnchor = (anchor: Anchor): anchor is DocumentAnchor =>
  !!(anchor as DocumentAnchor).document;

export const isAnchorEqual = (a: Anchor, b: Anchor): boolean => {
  if (isZoneAnchor(a) && isZoneAnchor(b)) {
    return a.zone === b.zone;
  }

  if (isDocumentAnchor(a) && isDocumentAnchor(b)) {
    return (
      a.document === b.document &&
      a.revision === b.revision &&
      a.anchor.node === b.anchor.node &&
      a.anchor.offset === b.anchor.offset &&
      a.focus.node === b.focus.node &&
      a.focus.offset === b.focus.offset
    );
  }

  return false;
};

/**
 * A type that keeps the minimum information needed about a comment,
 * with the goal to help comment zones to show if there's open comments
 * or not.
 */
export type Comment = {
  name: string;
  anchor?: Anchor;
  resolved: boolean;
};
